import "./uploadData.css";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doGet } from "../../../../utils/request";
import React, { useState, useEffect } from "react";
import DataTable from "../../../../Components/DataTable";
import moment from 'moment';
import * as propertyActions from "../../../../actionCreators/Property";

function HistoryTable({ uploadLookupData, getUploadLookupData, user }) {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [pageSize, setPageSize] = React.useState(10);

  const [isDistrictAdmin] = React.useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
  0 ? true : false);
  const [adminDistrictId] = React.useState(user?.currentUser?.data?.district?.id);

  useEffect(() => {
    getUploadLookupData({ page: 0, pageSize: pageSize, district_id: isDistrictAdmin && adminDistrictId ? adminDistrictId : null });
  }, []);
  useEffect(() => {
    if (uploadLookupData.data) {
      setData(uploadLookupData?.data);
      setLoading(uploadLookupData.loading);
      setPagination(uploadLookupData.pagination);
    }
  }, [uploadLookupData]);

  const handleTablePageChange = (tableChangeData, filters) => {
    const { current, pageSize } = tableChangeData;
    setPageSize(pageSize);
    getUploadLookupData({ page: current - 1, pageSize: pageSize, district_id: isDistrictAdmin && adminDistrictId ? adminDistrictId : null });
  };
  const downloadErrorReport = async (row) => {
    let fileDetails = await doGet(
      "/dataTable/error-report?parent_id=" + row.id
    );
    if (fileDetails.data.filename) {
      window.location =
        process.env.REACT_APP_SNG_STORAGE_SERVER_URL +
        "uploads/" +
        fileDetails.data.filename;
    } else {
      message.error("Download failed.");
    }
  };

  const tableColumns = [
    {
      title: "File Name",
      aligin: "center",
      dataIndex: "filename",
      render: (filename) => filename,
    },
    {
      title: "District",
      aligin: "center",
      dataIndex: "district",
      render: (district) => (district ? district.name : "---"),
    },
    {
      title: "Uploaded by",
      align: "center",
      dataIndex: "user",
      render: (user) => (user ? user.full_name : "---"),
    },
    {
      title: "Date Uploaded",
      align: "center",
      sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      dataIndex: "created_at",
      render: (date) => (date ? new Date(date).toDateString() : "---"),
    },
    {
      title: "No. of Entries",
      align: "center",
      sorter: (a, b) => a.entries - b.entries,
      dataIndex: "entries",
      render: (entries) => (entries ? entries : 0),
    },
    {
      title: "Upload Status",
      align: "center",
      dataIndex: "status",
      render: (status) => (status ? status : "---"),
    },
    {
      title: "Note",
      align: "center",
      dataIndex: "notes",
      render: (notes) => (notes ? notes : "---"),
    },
    {
      title: "Actions",
      align: "center",
      dataIndex: "status",
      render: (status, row) =>
        status === "ERROR" ? (
          <span
            style={{ color: "#2196F3", textDecoration: "underline" }}
            onClick={() => downloadErrorReport(row)}
          >
            View Report
          </span>
        ) : (
          "---"
        ),
    },
  ];

  return (
    <div className="history-table-container">
      <DataTable
        rowClassName="table-row-cursor-pointer"
        columns={tableColumns}
        pagination={pagination}
        loading={loading}
        data={data}
        handleTableValuesChange={handleTablePageChange}
        onRowClick={(record) => console.log(record)}
      />
    </div>
  );
}

const mapStateToProps = ({ user: user, property: { uploadLookupData } }) => ({
  uploadLookupData,
  user
});

const mapDispatchToProps = (dispatch) => ({
  getUploadLookupData: bindActionCreators(
    propertyActions.getUploadLookupData,
    dispatch
  ),
});
HistoryTable.propTypes = {
  getUploadLookupData: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTable);
